<!-- TEMPLATE DO POPOVER -->
<ng-template #ocrPopover>
  Valor extraído do documento:
  <b>{{ sourceText }}</b>
</ng-template>

<!-- ÍCONE -->
<span *ngIf="visible" #popRef="ngbPopover" class="ocr-source-icon" role="button" tabindex="0"
  [ngbPopover]="ocrPopover" popoverTitle="Origem do valor" triggers="mouseenter:mouseleave" container="body"
  aria-label="Ver origem do valor">
  <i data-feather="file-text"></i>
</span>